/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedCatalogLocationSeoFieldsAdmin } from './PaginatedCatalogLocationSeoFieldsAdmin'
import {
  PaginatedCatalogLocationSeoFieldsAdminFromJSON,
  PaginatedCatalogLocationSeoFieldsAdminFromJSONTyped,
  PaginatedCatalogLocationSeoFieldsAdminToJSON,
} from './PaginatedCatalogLocationSeoFieldsAdmin'

/**
 *
 * @export
 * @interface EnvelopedCatalogLocationSeoFieldsListCatalogLocationSeoFieldsAdmin
 */
export interface EnvelopedCatalogLocationSeoFieldsListCatalogLocationSeoFieldsAdmin {
  /**
   *
   * @type {PaginatedCatalogLocationSeoFieldsAdmin}
   * @memberof EnvelopedCatalogLocationSeoFieldsListCatalogLocationSeoFieldsAdmin
   */
  body: PaginatedCatalogLocationSeoFieldsAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedCatalogLocationSeoFieldsListCatalogLocationSeoFieldsAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedCatalogLocationSeoFieldsListCatalogLocationSeoFieldsAdmin interface.
 */
export function instanceOfEnvelopedCatalogLocationSeoFieldsListCatalogLocationSeoFieldsAdmin(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedCatalogLocationSeoFieldsListCatalogLocationSeoFieldsAdminFromJSON(
  json: any,
): EnvelopedCatalogLocationSeoFieldsListCatalogLocationSeoFieldsAdmin {
  return EnvelopedCatalogLocationSeoFieldsListCatalogLocationSeoFieldsAdminFromJSONTyped(
    json,
    false,
  )
}

export function EnvelopedCatalogLocationSeoFieldsListCatalogLocationSeoFieldsAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedCatalogLocationSeoFieldsListCatalogLocationSeoFieldsAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedCatalogLocationSeoFieldsAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedCatalogLocationSeoFieldsListCatalogLocationSeoFieldsAdminToJSON(
  value?: EnvelopedCatalogLocationSeoFieldsListCatalogLocationSeoFieldsAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedCatalogLocationSeoFieldsAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
